<template>
	<div class="main">
		<div>
			<h1
				style="font-size:22pt; line-height:241%; margin:17pt 0pt 16.5pt; orphans:0; page-break-after:avoid; page-break-inside:avoid; text-align:center; widows:0">
				<span style="font-family:宋体; font-size:22pt; font-weight:bold">隐私策略</span>
			</h1>
			<p>概要<br>
				欢迎您选择由百探集（以下简称“我们”。本指引中的百探集，具体是指王者战舰及其服务的提供方成都百探集科技有限公司）提供的王者战舰！除《王者战舰服务协议》外，我们还将通过《王者战舰隐私保护指引》（“本指引”）向您进一步细化说明您在使用王者战舰时我们收集、使用、存储和共享个人信息的情况，以及您所享有的相关权利等事宜，本指引中要点如下：
			</p>

			<p>•&nbsp;为了向您提供游戏娱乐以及与此相关的消费等服务，我们需要收集您的游戏历史、设备信息、登录日志等信息。</p>

			<p>•&nbsp;为更好地保护未成年人身心健康，促使未成年人健康上网，我们可能在国家有关网络游戏防沉迷政策规定的基础上，实施更为严格的防沉迷措施。同时我们也不断研究与测试各种保护未成年人的新技术。</p>

			<p>•&nbsp;您可以根据本指引所述管理您的个人信息以及相关授权。</p>

			<p>•&nbsp;我们采用多方位的安全保护措施，以确保对您的个人信息保护处于合理的安全水平。</p>

			<p>您可以通过阅读完整版《王者战舰隐私保护指引》，了解个人信息类型与用途的对应关系等更加详尽的个人信息处理规则。</p>

			<p>1.我们收集的信息</p>

			<p>2.信息的存储</p>

			<p>3.信息的安全</p>

			<p>4.我们如何使用信息</p>

			<p>5.对外提供</p>

			<p>6.您的权利</p>

			<p>7.变更</p>

			<p>8.未成年人保护</p>

			<p>9.其他</p>

			<p>10.联系我们</p>

			<p>1.我们收集的信息<br>
				在您使用王者战舰服务的过程中，王者战舰会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供、优化我们的服务以及保障您的账户安全：<br>
				<br>
				1.1&nbsp;当您注册或使用王者战舰服务时，我们会收集您的网络身份标识信息及个人常用设备信息，用于标记您为王者战舰的用户。如果您使用微信、QQ及（或）我们认可的其他账号（以下称“第三方账号”）作为游戏账号关联登录王者战舰的，我们会收集您微信、QQ及第三方账号的唯一标识、头像、昵称，用于保存您的登录信息，以便您在不同设备登录。
			</p>

			<p>如果您使用微信、QQ及（或）第三方账号作为游戏账号关联登录王者战舰的，为了更好地向您提供游戏服务，改善游戏体验，我们会收集您的QQ号码、微信账号以及第三方账号涉及的唯一标识、昵称、头像、好友关系以及您授权的其他信息，以及您在王者战舰中的相关操作信息、游戏信息等信息（具体包括但不限于您的登录状态、对局信息/状态等）进行使用，并可向您本人或其他用户展示。我们可能会视游戏产品具体情况为您提供相关权限，以便您可以对是否展示前述相关信息进行相应设置。
			</p>

			<p>1.2&nbsp;为满足相关法律法规政策及相关主管部门的要求，王者战舰用户需进行实名认证以继续使用和享受王者战舰。我们会在获得您同意或您主动提供的情况下收集您的实名身份信息（包括姓名、身份证号、照片等信息），该信息属于敏感信息，拒绝提供实名身份信息可能会导致您在使用王者战舰过程中受到相应限制。<br>
				<br>
				1.3&nbsp;为保障您正常使用我们的服务，维护游戏基础功能的正常运行，优化游戏产品性能，提升您的游戏体验并保障您的账号安全，我们会收集您的设备ID、设备名称、设备类型和版本、系统版本、IP地址、MAC地址、应用ID、网络类型等信息。
			</p>

			<p>1.4&nbsp;当您使用王者战舰服务时，我们会收集您的游戏日志信息，例如登录日志、物品日志、游戏对局信息等，以便您能够在客户端查看您的相关历史记录，同时用于游戏运营统计分析、客服投诉处理及其他游戏安全分析，并为提升您的游戏体验，我们可能把前述信息同步至该游戏后续版本中。
			</p>

			<p>1.5&nbsp;如您使用小米、魅族、华为等品牌手机，王者战舰接入的上述手机厂商Push&nbsp;SDK需要收集手机唯一标识信息（例如IMEI），并可能会收集您的手机型号、系统类型、系统版本、设备屏幕尺寸等参数用于实现王者战舰产品和活动等信息的推送，具体情况请参见SDK运营方的隐私政策或相关声明。<br>
				<br>
				1.6&nbsp;当您使用王者战舰产品的消费功能时，我们会收集您的充值记录、消费记录等信息，以便您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。充值记录、消费记录属于敏感信息，收集上述信息为实现王者战舰产品的消费功能所必须，否则将无法完成交易。
			</p>

			<p>1.7&nbsp;为保障您的游戏账号安全，营造公平、健康及安全的游戏环境，我们会收集您的游戏识别信息、硬件及操作系统信息、进程及游戏崩溃记录等信息，以用于打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊等）。<br>
				<br>
				1.8&nbsp;我们可能会将您的游戏数据进行分析以了解您的偏好，以便于我们更好地在王者战舰中向您展示可能感兴趣的内容。</p>

			<p>1.9&nbsp;根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：</p>

			<p>1）&nbsp;与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；</p>

			<p>2）&nbsp;与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>

			<p>3）&nbsp;出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</p>

			<p>4）&nbsp;所收集的个人信息是您自行向社会公众公开的；</p>

			<p>5）&nbsp;从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>

			<p>6）&nbsp;根据您要求签订和履行合同所必需的；</p>

			<p>7）&nbsp;用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>

			<p>8）&nbsp;为开展合法的新闻报道所必需的；</p>

			<p>9）&nbsp;出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>

			<p>10）&nbsp;法律法规规定的其他情形。</p>

			<p>1.10&nbsp;请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
			</p>

			<p>目前，除了向第三方调研机构收集游戏调研信息以帮助我们改进游戏产品以及提供个性化服务，以及本指引第1.1条规定的您使用第三方账号登录王者战舰情形之外，我们不会主动从王者战舰外的第三方获取您的个人信息。如未来为业务发展需要从王者战舰外的第三方间接获取并处理您的个人信息的，我们会严格遵守相关法律法规的规定，要求该第三方征得您的同意并确保其提供的信息的合法性。
			</p>

			<p>2.信息的存储<br>
				2.1&nbsp;信息存储的方式和期限<br>
				我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。</p>

			<p>一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。</p>

			<p>2.2&nbsp;信息存储的地域<br>
				我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>

			<p>2.3&nbsp;产品或服务停止运营时的通知<br>
				当我们的产品或服务发生停止运营的情况时，我们将根据相关法律法规规定进行公告通知，并依法保障您的合法权益。</p>

			<p>3.信息安全<br>
				3.1&nbsp;安全保护措施<br>
				我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。
			</p>

			<p>我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。此外，我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作，以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。
			</p>

			<p>我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。
			</p>

			<p>我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。</p>

			<p>3.2&nbsp;安全事件处置措施<br>
				若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会以公告、推送通知或邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
			</p>

			<p>4.我们如何使用信息<br>
				我们严格遵守法律法规的规定以及与用户的约定，按照本指引及《王者战舰服务协议》、《王者战舰隐私政策》所述使用收集的信息，以向您提供更为优质的服务。<br>
				4.1&nbsp;信息使用规则<br>
				我们会按照如下规则使用收集的信息：</p>

			<p>1)&nbsp;我们会根据我们收集的信息向您提供各项功能与服务，包括基础游戏功能、消费功能等；</p>

			<p>2)&nbsp;我们会根据您使用王者战舰产品的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合。
			</p>

			<p>4.2&nbsp;告知变动目的后征得同意的方式<br>
				我们将会在本指引所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。</p>

			<p>5.对外提供<br>
				目前，除本指引以及《王者战舰服务协议》规定的情形之外，我们不会主动共享、提供或转让您的个人信息至王者战舰外的第三方，如存在其他共享、提供或转让您的个人信息或您需要我们将您的个人信息共享、提供或转让至王者战舰外的第三方情形时，我们会直接或确认该第三方征得您对上述行为的明示同意。
			</p>

			<p>即使有前款规定，我们也会在疑似未成年人消费后，尝试联系其监护人，将相关消费记录等信息告知其监护人，进行提醒、确认与处理。</p>

			<p>除本指引以及《王者战舰服务协议》、《王者战舰隐私政策》另有规定外，我们不会对外公开披露所收集的个人信息。如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
			</p>

			<p>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息。</p>

			<p>另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：</p>

			<p>1）&nbsp;与国家安全、国防安全直接相关的；</p>

			<p>2）&nbsp;与公共安全、公共卫生、重大公共利益直接相关的；</p>

			<p>3）&nbsp;与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>

			<p>4）&nbsp;出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>

			<p>5）&nbsp;个人信息主体自行向社会公众公开个人信息的；</p>

			<p>6）&nbsp;从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

			<p>6.您的权利<br>
				在您使用王者战舰服务期间，我们可能会视游戏产品具体情况为您提供相应的操作设置，以便您可以查询、删除、更正或撤回您的相关个人信息，您可参考相应游戏产品的具体指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。
			</p>

			<p>7.变更<br>
				我们可能会适时对本指引进行修订。当本指引的条款发生变更时，我们会在版本更新时以适当的方式向您提示变更后的指引。请您仔细阅读变更后的隐私保护指引或指引内容，您继续使用王者战舰戏表示您同意我们按照更新后的隐私保护指引收集、处理或使用您的个人信息。
			</p>

			<p>8.未成年人保护<br>
				我们高度重视未成年人个人信息的保护问题，并持续探索更新的未成年人个人信息保护方式。</p>

			<p>我们会积极按照国家防沉迷政策要求，通过启用防沉迷系统保护未成年人的合法权益。我们会通过实名身份等信息校验判断相关账号的实名信息是否为未成年人，进而决定是否将此账号纳入到防沉迷体系中。另外，我们会收集您的登录时间、游戏时长等信息，通过从系统层面自动干预和限制未成年人游戏时间、启用强制下线功能等方式，引导未成年人合理游戏，并在疑似未成年人消费后尝试联系其监护人进行提醒、确认与处理，帮助未成年人健康上网。
			</p>

			<p>同时，为更好地保护未成年身心健康，促使未成年人健康上网，我们可能在国家有关网络游戏防沉迷政策规定的基础上，实施更为严格的防沉迷措施。同时我们也不断研究与测试各种保护未成年人的新技术。</p>

			<p>另外，我们还可能会通过收集您在游戏过程中产生的游戏行为数据（如您在终端设备操作游戏时形成的点击压力和半径、点击相对位置、加速度方向、重力方向等数据。<br>
				<br>
				9.安卓版本涉及嵌入第三方代码、插件传入个人信息情形列举如下：<br>
				1）微信opensdk获取的权限imei、imsi、系统版本，mac地址、sd卡读写、网络类型。用途：实现用户微信登录，使用分享到微信功能，使用微信头像和昵称。<br>
				2）buglysdk获取的权限手机设备信息、网络状态、手机品牌、android系统版本、android系统api等级、厂商系统版本。用途：排查崩溃问题，帮助app提升稳定性。<br>
				3）移动安全联盟sdk获取的权限手机设备信息(设备制造商、设备型号、设备品牌)、网络信息。用途：获取设备oaid<br>
				4）支付宝支付sdk获取的权限imei、imsi、mac地址、设备型号、设备品牌、操作系统、IP地址、网络类型、运营商信息、Wi-Fi状态、Wi-Fi参数。用途：保障用户账户和资金安全以及支付服务的安全稳定运行，履行反洗钱、反恐怖融资、反电信网络诈骗等法定义务，实现网络链路的选择和优化提升用户体验<br>
				<br>
				10.其他<br>
				《王者战舰隐私政策》是一般性隐私条款，其中所规定的内容包括但不限于用户权利及信息安全保障措施等均适用于王者战舰用户。如《王者战舰隐私政策》与本指引存在不一致或矛盾之处，请以本指引为准。</p>

			<p>11.联系我们<br>
				当您有其他的投诉、建议、未成年人个人信息相关问题时，请通过游戏内客服通道&nbsp;与我们联系。</p>

			<p>我们将尽快审核所涉问题，并在验证您的用户身份后的十五天内予以回复。</p>
		</div>
	</div>
</template>
  
  <script>
	export default {
		data() {
			return {
				fileContent: '' ,
			}
		},
		created(){
			document.title="隐私策略";
		},
		mounted() {
		},
		methods: {
		
		}
	}
</script>
<style scoped>

</style>